// extracted by mini-css-extract-plugin
export default {"chartContainer":"GainChartComponent_chartContainer__v8zs0","borderContainer":"GainChartComponent_borderContainer__JurT3","chartBtns":"GainChartComponent_chartBtns__iK1tU"};